import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/modules/auth/forgot-password/forgot-password-view.tsx");
